import { useMemoizedFn } from 'ahooks';
import cn from 'classnames';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@leadsnavi/ui-kit';
import ScanSearchIcon from '@/assets/icons/scan-search.svg?react';
import ChevronDownIcon from '@/assets/icons/chevron-down.svg?react';
import CheckIcon from '@/assets/icons/check.svg?react';
import styles from './index.module.scss';

interface MatchItem {
  label: string;
  checked: boolean;
}

interface MatchBadgeProps {
  text: string;
  matches: MatchItem[];
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const MatchBadge: React.FC<MatchBadgeProps> = ({ text, matches, leftIcon, rightIcon, onClick, className }) => {
  const handleClick = useMemoizedFn(() => {
    if (onClick) {
      onClick();
    }
  });

  const defaultLeftIcon = <ScanSearchIcon className="w-[14px] h-[14px] text-white" />;
  const defaultRightIcon = <ChevronDownIcon className="w-[14px] h-[14px] text-[#059669]" />;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={cn(
              'flex items-center gap-1 px-[8px] py-[2px] rounded-[14px] h-[22px] w-fit bg-[#ECFDF5] cursor-pointer hover:bg-[#D1FAE5]',
              className
            )}
            onClick={handleClick}
          >
            {leftIcon || defaultLeftIcon}
            <span className="text-[12px] font-normal text-[#059669]">{text}</span>
            {rightIcon || defaultRightIcon}
          </div>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          arrowClassName={styles.tooltipContent}
          className={cn('flex flex-col gap-[4px] py-2 px-3  bg-white rounded-lg shadow-md border-none')}
        >
          {matches.map((match, index) => (
            <div key={index} className="flex items-center gap-[4px] ">
              {match.checked && <CheckIcon className="w-[14px] h-[14px] text-[#10B981]" />}
              <span className="text-[12px] font-normal text-[#262626]">{match.label}</span>
            </div>
          ))}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
